import { SignRepository } from '../../domain/repositories/sign.repository';
import { signRepository } from '../repositories/sign.repository';

export const signRepositoryInstance: SignRepository = signRepository();
